// Copyright (c) 2025 Audere, All Rights Reserved

import {
  Typography,
  Divider,
  Box,
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { createStyleSheet } from "../utils/styles";
import { useTranslation } from "react-i18next";
import type { SdkApkDownloadDialogProps } from "../types/projects";
import { theme } from "../../theme";

const SdkApkDownloadDialog = ({ open, onClose, onDownloadSdk }: SdkApkDownloadDialogProps) => {
  const { t } = useTranslation("SdkApkDownloadDialog");

  const downloadItems = [
    { key: t("sdk"), title: t("downloadSdk") },
    // { key: t("apk"), title: t("downloadApk") },
    // TODO: Currently not supported as per api documentation, so commented out.
  ];

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle sx={styles.dialogTitle}>{t("SdkApkDownloadTitle")}</DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        {downloadItems.map(item => (
          <Box key={item.key}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" py={2}>
              <Box>
                <Typography variant="caption" color="text.secondary">
                  {t(item.key)}
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {t(item.title)}
                </Typography>
              </Box>
              <Button
                variant="outlined"
                sx={styles.downloadBtn}
                onClick={onDownloadSdk}
                data-testid="download-btn"
              >
                {t("common:download")}
              </Button>
            </Stack>
            <Divider />
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button onClick={onClose} variant="contained" color="primary" sx={styles.closeBtn}>
          {t("common:close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SdkApkDownloadDialog;

const styles = createStyleSheet({
  dialogTitle: {
    mb: 2,
  },
  dialogContent: {
    px: 3,
    py: 2,
  },
  dialogActions: {
    my: 1,
    px: 3,
  },
  downloadBtn: {
    borderColor: theme.palette.action.disabled,
    color: theme.palette.common.black,
  },
  closeBtn: {
    px: 4,
  },
});
